import { clearCaregiverImpersonationState } from '@leagueplatform/caregiver';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';

export const logout = (returnTo?: string) => {
  clearCaregiverImpersonationState();
  StandaloneAuth.client.logout({
    returnTo: returnTo ?? window.location.origin,
  });
};
